import { useQuery } from "@tanstack/react-query";

import { Button } from "@/shared/ui/button";

import { educationApplicationsQueryOptions } from "./query-options";

const STATUS_LABELS = {
  pending: "审核中",
  approved: "已通过",
  rejected: "未通过",
} as const;

export function EducationSubscriptionSection({ userId, onNavigate }: { userId: string; onNavigate: () => void }) {
  const { data, isError, isLoading } = useQuery({
    ...educationApplicationsQueryOptions(userId, 1, 1),
    enabled: Boolean(userId),
  });
  const latest = data?.applications[0];

  return (
    <div className="border-t border-border/50 py-5">
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="text-sm font-medium">教育优惠</p>
          <p className="mt-1 text-xs leading-5 text-muted-foreground">
            {isLoading ? "正在查询申请状态…" : isError ? "暂时无法查询申请状态" : latest
              ? `最近申请：${STATUS_LABELS[latest.status] ?? latest.status}`
              : "学生和教师经审核后可获一年教育版权益。"}
          </p>
        </div>
        <Button type="button" variant="outline" size="sm" onClick={onNavigate}>
          {latest ? "查看申请" : "了解并申请"}
        </Button>
      </div>
    </div>
  );
}
